module.exports = __webpack_public_path__ + "static/img/blue-judge.16cddd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue-judge.png
// module id = Ir5W
// module chunks = 32